import uuidv4 from "uuid/v4";

import { closeResponse, createPropertyEvent } from "../appsyncOperations";
import * as actions from "../../store/actions";
import store from "../../store";

const resolveResponse = async ({ property, appUser, navigate }) => {
  const { propertyId } = property;
  try {
    const newProperty = await closeResponse(propertyId);
    navigate(newProperty);
    const event = await createPropertyEvent({
      eventId: uuidv4(),
      icon: "APP",
      text: `Response resolved by ${appUser.displayName}`,
      senderName: "Kirs",
      senderId: "KIRS",
      propertyId,
      serviceProviderId: appUser.serviceProviderId,
      instanceId: property.instanceId,
    });
    store.dispatch(actions.properties.setProperty(newProperty));
    store.dispatch(actions.properties.setPropertyEvent(event));
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export default resolveResponse;
